<div
  class="select d-flex direction-column"
  [ngClass]="{ 'store-config': isStoreConfig, 'select--modern': appearance === 'modern' }"
>
  <label class="select-label" [for]="selectId" [ngClass]="{ 'select-label--modern': appearance === 'modern' }">
    {{ label }}
    <span *ngIf="required && appearance === 'modern'" class="select-required"></span>
  </label>
  <div class="select-field field d-flex justify-flex-end align-center">
    <select
      #select
      [id]="selectId"
      [name]="selectId"
      class="field-input input"
      [ngClass]="{ 'field-input--modern': appearance === 'modern', 'field-input--invalid': appearance === 'modern' && hasErrorState }"
      [disabled]="disabled"
      [required]="required"
      [attr.aria-required]="required ? true : null"
      [attr.aria-invalid]="hasErrorState ? true : null"
      [attr.aria-describedby]="describedBy"
      [(ngModel)]="value"
      (ngModelChange)="value = $event; onChange($event)"
    >
      <option
        [value]="valueDefault"
        hidden
        disabled
        selected
        class="input-placeholder"
      >
        {{ placeholder }}
      </option>
      <option *ngFor="let item of data" [value]="item.id">
        {{ item?.name }}
      </option>
    </select>
    <app-svg-icon
      src="../../../../assets/icons/arrow-select-icon.svg"
      color="lightGray"
      width="20px"
      height="19px"
      class="field-icon mr-10"
      [ngClass]="{ 'mt-5': isStoreConfig, 'field-icon--modern': appearance === 'modern' }"
    >
    </app-svg-icon>
  </div>
  <div *ngIf="appearance === 'modern'" class="select-meta" aria-live="polite">
    <span *ngIf="!hasErrorState && hint" [id]="hintId" class="select-hint">{{ hint }}</span>
    <span *ngIf="hasErrorState" [id]="errorId" class="select-error" role="alert">{{ currentErrorMessage }}</span>
  </div>
</div>
